import React from 'react'

interface GradientNumberProps {
    children: React.ReactNode
    fontSize?: number
    yOffset?: number
}

const GradientNumber: React.FC<GradientNumberProps> = ({ children, fontSize = 150, yOffset = 0 }) => {
    const boxSize = fontSize * 1.4

    return (
        <svg viewBox={`0 0 ${boxSize} ${boxSize}`} width={boxSize} height={boxSize}>
            <defs>
                {/* Fill gradient (green) */}
                <linearGradient id="fillGradient" gradientTransform="rotate(90)">
                    <stop offset="10.76%" stop-color="#00330F" />
                    <stop offset="42.24%" stop-color="#049248" />
                    <stop offset="86.03%" stop-color="#00330F" />
                </linearGradient>

                {/* Stroke gradient (gold) */}
                <linearGradient id="strokeGradient" gradientTransform="rotate(90)">
                    <stop offset="15.43%" stopColor="#856220" />
                    <stop offset="34.91%" stopColor="#F4E683" />
                    <stop offset="50.85%" stopColor="#BF923D" />
                    <stop offset="68.56%" stopColor="#4E341B" />
                    <stop offset="86.26%" stopColor="#F1EA82" />
                </linearGradient>
            </defs>

            <text
                x="50%"
                y="50%"
                dy={`${yOffset}px`}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={fontSize}
                fontWeight="700"
                fill="url(#fillGradient)"
                stroke="url(#strokeGradient)"
                strokeWidth={Math.max(1, fontSize * 0.04)}
                paintOrder="stroke"
                strokeLinejoin="round"
            >
                {children}
            </text>
        </svg>
    )
}

export default GradientNumber
